import { TrailDifficulty } from './Trails';

export interface Review {
  id: number;
  text?: string;
  rating: number;
  reference: string;
  status: ReviewStatus;
  difficulty?: TrailDifficulty;
  createdAt: Date;
  updatedAt: Date;
  user: ReviewUser;
  photos: string[];
  trail?: ReviewTrail;  
}

export interface ReviewTrail {
  id: number;
  name: string;
}

export interface ReviewUser {
  id: number;
  name?: string;
  email?: string;
}

export enum ReviewStatus {
  Active = 'active',
  Deleted = 'deleted',
  Pending = 'pending'
}

export const getStatusBadge = (status: ReviewStatus) => {
  switch (status) {
    case ReviewStatus.Active:
      return { variant: 'success', text: 'Active' };
    case ReviewStatus.Pending:
      return { variant: 'warning', text: 'Pending' };
    case ReviewStatus.Deleted:
      return { variant: 'danger', text: 'Deleted' };
    default:
      return { variant: 'secondary', text: 'Unknown' };
  }
};

export const getRatingStars = (rating: number) => {
  return '⭐'.repeat(Math.max(0, Math.min(5, rating)));
};
